import { render, staticRenderFns } from "./CaseModal.vue?vue&type=template&id=11bb2507&scoped=true&"
import script from "./CaseModal.vue?vue&type=script&lang=js&"
export * from "./CaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb2507",
  null
  
)

export default component.exports